import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	toolbarName: {
		id: 'floating-toolbar.common.toolbar-name',
		defaultMessage: 'Bulk actions',
		description: 'The text will show when the toolbar is focused',
	},
});
